module.exports = __webpack_public_path__ + "static/media/CS143.d8737a36.PNG";